import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "materialDetailsView flex-node-col" }
const _hoisted_2 = { class: "flex-item-scroll" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "flex-container-col gap10" }
const _hoisted_5 = { class: "flex-container-row gap10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_material_picture = _resolveComponent("material-picture")!
  const _component_my_icon = _resolveComponent("my-icon")!
  const _component_card_title = _resolveComponent("card-title")!
  const _component_card_header = _resolveComponent("card-header")!
  const _component_card_body = _resolveComponent("card-body")!
  const _component_card = _resolveComponent("card")!
  const _component_stock_indicator = _resolveComponent("stock-indicator")!
  const _component_doc_link = _resolveComponent("doc-link")!
  const _component_material_link_section = _resolveComponent("material-link-section")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.materialText(_ctx.materialData)), 1),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.salesText)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.salesText), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_material_picture, {
          "material-data": _ctx.materialData,
          "max-height": 300
        }, null, 8, ["material-data"]),
        (_ctx.showOrderingSection)
          ? (_openBlock(), _createBlock(_component_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_card_header, { class: "k-hstack subsection" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_my_icon, { icon: "cart" }),
                    _createVNode(_component_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.localize('ordering')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_card_body, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_card, { class: "label" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_card_header, { class: "label" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_card_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.localize('Price')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_card_body, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.priceData), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_ctx.isAdmin)
                        ? (_openBlock(), _createBlock(_component_card, { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_card_header, { class: "label" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_card_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.localize('Inventory')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_card_body, { class: "text-right" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.numberFormatter(_ctx.materialData.availableStock)), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_card, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_card_header, { class: "label" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_card_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.localize('Status')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_card_body, { class: "text-right" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_stock_indicator, { "material-item": _ctx.materialData }, null, 8, ["material-item"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.additionalDocsForEveryone?.length)
          ? (_openBlock(), _createBlock(_component_card, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_card_header, { class: "k-hstack subsection" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_my_icon, { icon: "attachment" }),
                    _createVNode(_component_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.localize('documents')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_card_body, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additionalDocsForEveryone, (doc) => {
                      return (_openBlock(), _createBlock(_component_doc_link, {
                        key: doc.blobName,
                        doc: doc,
                        style: {"margin-left":"10px"}
                      }, null, 8, ["doc"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.additionalDocsForAdmins?.length)
          ? (_openBlock(), _createBlock(_component_card, { key: 2 }, {
              default: _withCtx(() => [
                _createVNode(_component_card_header, { class: "k-hstack subsection" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_my_icon, { icon: "attachment" }),
                    _createVNode(_component_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.localize('documentsForAdminsSectionTitle')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_card_body, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.additionalDocsForAdmins, (doc) => {
                      return (_openBlock(), _createBlock(_component_doc_link, {
                        key: doc.blobName,
                        doc: doc,
                        style: {"margin-left":"10px"}
                      }, null, 8, ["doc"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.materialData.hasReplacement)
          ? (_openBlock(), _createBlock(_component_material_link_section, {
              key: 3,
              title: _ctx.localize('replacement'),
              avatar: "replacement",
              materials: _ctx.materialData.replacementItems
            }, null, 8, ["title", "materials"]))
          : _createCommentVNode("", true),
        (_ctx.materialData.hasProductionBom)
          ? (_openBlock(), _createBlock(_component_material_link_section, {
              key: 4,
              title: _ctx.localizeBomItemText('BOMitems_Production'),
              avatar: "production",
              materials: _ctx.materialData.productionItems
            }, null, 8, ["title", "materials"]))
          : _createCommentVNode("", true),
        (_ctx.materialData.hasBoughtWithBom)
          ? (_openBlock(), _createBlock(_component_material_link_section, {
              key: 5,
              title: _ctx.localizeBomItemText('BOMitems_Recommended'),
              avatar: "recommended",
              materials: _ctx.materialData.recommendedItems
            }, null, 8, ["title", "materials"]))
          : _createCommentVNode("", true),
        (_ctx.materialData.hasMaintenanceBom)
          ? (_openBlock(), _createBlock(_component_material_link_section, {
              key: 6,
              title: _ctx.localizeBomItemText('BOMitems_Maintenance'),
              avatar: "maintenance",
              materials: _ctx.materialData.maintenanceItems
            }, null, 8, ["title", "materials"]))
          : _createCommentVNode("", true),
        (_ctx.materialData.hasAlternativeItemsBom)
          ? (_openBlock(), _createBlock(_component_material_link_section, {
              key: 7,
              title: _ctx.localizeBomItemText('BOMitems_Alternatives'),
              avatar: "alternative",
              materials: _ctx.materialData.alternativeItems
            }, null, 8, ["title", "materials"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}